import React from 'react';
import { company } from '../data/content';

const WA_NUMBER = '49' + company.phoneRaw.replace(/^0/, '');
const WA_TEXT = encodeURIComponent('Hallo Die Haushelden, ich hätte gerne eine kostenlose Einschätzung.');

export default function WhatsAppButton() {
  return (
    <a
      href={`https://wa.me/${WA_NUMBER}?text=${WA_TEXT}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Per WhatsApp schreiben"
      data-testid="whatsapp-button"
      className="fixed bottom-5 right-5 md:bottom-7 md:right-7 z-[60] group flex items-center gap-3"
    >
      <span className="hidden md:block bg-white text-[#0B1E44] text-sm font-semibold px-4 py-2 rounded-full shadow-[0_8px_24px_rgba(0,0,0,0.25)] opacity-0 translate-x-3 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
        Jetzt per WhatsApp schreiben
      </span>
      <span className="relative w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_10px_30px_rgba(37,211,102,0.45)] hover:scale-105 transition-transform duration-300">
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" aria-hidden />
        <svg viewBox="0 0 32 32" className="relative w-8 h-8 md:w-9 md:h-9 fill-white" aria-hidden>
          <path d="M16 3C8.8 3 3 8.7 3 15.8c0 2.5.7 4.9 2 7L3 29l6.4-1.9c2 1.1 4.3 1.7 6.6 1.7 7.2 0 13-5.7 13-12.8S23.2 3 16 3zm0 23.3c-2.1 0-4.1-.6-5.8-1.6l-.4-.2-3.8 1.1 1.1-3.6-.3-.4c-1.2-1.8-1.8-3.9-1.8-6 0-5.8 4.9-10.5 11-10.5s11 4.7 11 10.5-4.9 10.7-11 10.7zm6-7.9c-.3-.2-1.9-1-2.2-1.1-.3-.1-.5-.2-.8.2-.2.3-.9 1.1-1.1 1.3-.2.2-.4.3-.7.1-.3-.2-1.4-.5-2.6-1.6-1-.9-1.6-1.9-1.8-2.3-.2-.3 0-.5.1-.7l.6-.7c.2-.2.2-.4.3-.6.1-.2 0-.4 0-.6-.1-.2-.8-1.8-1-2.5-.3-.7-.6-.6-.8-.6h-.7c-.2 0-.6.1-.9.4-.3.3-1.2 1.2-1.2 2.9s1.2 3.3 1.4 3.6c.2.2 2.4 3.6 5.8 5 .8.3 1.4.5 1.9.7.8.3 1.5.2 2.1.1.6-.1 1.9-.8 2.2-1.5.3-.8.3-1.4.2-1.5-.1-.2-.3-.3-.6-.4z" />
        </svg>
      </span>
    </a>
  );
}
